import EthSync from './EthSync';

export default EthSync;
